import { genComponentStyleHook, type FullToken } from '../geek/styleUtil'
import { cyan, neonMd, transition, getGlassStyle, pulseKeyframes } from './neonUtil'
import { DOT_PREFIX } from './constant'

export default genComponentStyleHook(['Card', 'cyberTheme'], (token: FullToken) => {
  const { componentCls } = token

  return {
    [`${componentCls}${DOT_PREFIX}`]: {
      transition,
      borderRadius: 4,
      overflow: 'hidden',
      position: 'relative' as const,
      ...getGlassStyle('heavy'),
      border: `1px solid ${cyan[500]}20`,
      boxShadow: `0 0 1px ${cyan[500]}40`,

      // 呼吸动画
      animationName: pulseKeyframes,
      animationDuration: '4s',
      animationIterationCount: 'infinite',
      animationTimingFunction: 'ease-in-out',

      // hover 时增强发光
      '&:hover': {
        borderColor: `${cyan[500]}40`,
        boxShadow: neonMd,
        '&:before': { opacity: 1 },
      },

      // 顶部荧光线装饰
      '&:before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        height: 1,
        background: `linear-gradient(90deg, transparent, ${cyan[500]}60, transparent)`,
        opacity: 0.6,
        transition,
        pointerEvents: 'none',
      },

      // 卡片头部
      [`${componentCls}-head`]: {
        borderBottom: `1px solid ${cyan[500]}12`,
        background: `${cyan[500]}04`,

        [`${componentCls}-head-title`]: {
          color: `${cyan[200]} !important`,
          fontWeight: 600,
          letterSpacing: '0.5px',
        },
      },

      // 卡片内容
      [`${componentCls}-body`]: {
        background: 'transparent',
      },
    },
  }
})
